import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEventCallback } from 'usehooks-ts';

import { getValorantAgentsOptions } from '@/features/games/valorant/hooks/useGetValorantAgents';
import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { getMyProfileOptions } from '@/features/profile/hooks/useGetMyProfile/getMyProfile.options';
import { MyProfileEdit } from '@/features/user/components/myProfileEdit';
import { MyProfileEditSkeleton } from '@/features/user/components/myProfileEdit/myProfileEditSkeleton';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';
import { Button } from '@/shared/components/ui/button';

export const Route = createFileRoute('/_protected/_app/_mainLayout/me/edit')({
  loader: async ({ context }) => {
    const [profileData] = await Promise.all([
      context.queryClient.ensureQueryData(getMyProfileOptions()),
      context.queryClient.ensureQueryData(getValorantAgentsOptions()),
    ]);

    if (profileData.profile?.riotPuuid) {
      await context.queryClient.ensureQueryData(
        getValorantPlayerOptions({ puuid: profileData.profile.riotPuuid }),
      );
    }
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
});

function PendingComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    void navigate({ to: '/me' });
  });

  return (
    <MainLayout.Root>
      <PageHeader.Root className="border-warm-600 bg-cold-950/80 sticky top-0 z-10 border-b md:border-b-0 md:bg-transparent">
        <PageHeader.BackButton onClick={handleGoBack} />
        <Button size="sm" disabled>
          Done
        </Button>
      </PageHeader.Root>
      <MainLayout.Content className="w-full px-5 pt-6">
        <MyProfileEditSkeleton />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}

function RouteComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    void navigate({ to: '/me' });
  });

  return (
    <MainLayout.Root>
      <PageHeader.Root className="border-warm-600 bg-cold-950/80 sticky top-0 z-10 border-b md:border-b-0 md:bg-transparent">
        <PageHeader.BackButton onClick={handleGoBack} />
        <Button onClick={handleGoBack} size="sm">
          Done
        </Button>
      </PageHeader.Root>
      <MainLayout.Content className="w-full px-5 pt-6">
        <MyProfileEdit />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
